import { Text } from '@chakra-ui/react';
import RoutableModal from 'components/general/RoutableModal';
import { FormProvider } from 'react-hook-form';
import DocumentSettingsForm from './DocumentSettingsForm';
import { useDocumentSettingsForm } from './lib';

function DocumentSettings() {
  const { form, onSubmit, loading, initialLoadDone } = useDocumentSettingsForm();

  return (
    <RoutableModal
      title="Document Settings"
      buttons={{ action: { text: 'Save', handler: onSubmit } }}
      loading={loading}
    >
      <Text mb={10}>
        Here you can adjust settings for this document. Please make sure to either provide an
        expiration date or mark the document as non-expiring.
      </Text>
      <FormProvider {...form}>{initialLoadDone && <DocumentSettingsForm />}</FormProvider>
    </RoutableModal>
  );
}

export default DocumentSettings;
